import ActionButton from 'components/ActionButton';
import moment from 'moment';
import { func } from 'prop-types';
import React from 'react';
import Divider from '../components/Divider';
import ContentColumns from '../components/ContentColumns';

import { CancelText } from './Intro.less';
import AlertDialog from 'components/AlertDialog';

class Intro extends React.Component {
  state = {
    alertOpen: false,
  };

  cancelRehab = () => {
    const { onCancelRehab } = this.props;
    this.setState({ alertOpen: false });
    onCancelRehab();
  };
  startRehab = () => {
    const { onChangeParent, changeStep } = this.context;
    onChangeParent('start', moment().toISOString());
    changeStep(1);
  };

  openAlertDialog = () => {
    this.setState({ alertOpen: true });
  };

  render() {
    const { fm } = this.context;
    return (
      <div>
        <ContentColumns
          firstColumn={
            <div>
              <h1>{fm('onlineRehabilitation.intro.title')}</h1>
              <span>{fm('onlineRehabilitation.intro.text')}</span>
            </div>
          }
          secondColumn={
            /* <div>
          <div className={VideoContainer}>Video</div>
          </div> */ null
          }
        />
        <div>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '2rem' }}>
            <ActionButton
              localeId="onlineRehabilitation.intro.startNow"
              onClick={this.startRehab}
              style={{ fontSize: '2.2rem' }}
              filledSecondary
            />
          </div>
          <Divider />
          <div style={{ display: 'flex' }}>
            <div style={{ marginRight: '4rem' }}>
              <ActionButton
                localeId="onlineRehabilitation.intro.cancelRehab"
                onClick={this.openAlertDialog}
                style={{ textTransform: 'none' }}
                secondary
                border
              />
            </div>
            <div className={CancelText}>
              <div style={{ width: '80%' }}>{fm('onlineRehabilitation.intro.cancelRehabText')}</div>
            </div>
          </div>
        </div>
        <AlertDialog
          visible={this.state.alertOpen}
          alertMessage="onlineRehabilitation.cancelAlert"
          formatMessage={props => fm(props.id)}
          onCancel={() => this.setState({ alertOpen: false })}
          onAccept={this.cancelRehab}
          cancelButtonText="remove.cancel"
          acceptButtonText="remove.accept"
          cancelButtonStyle={{ button: 'raised', primary: true }}
          acceptButtonStyle={{ button: 'flat', primary: true }}
        />
      </div>
    );
  }
}

Intro.contextTypes = {
  fm: func,
  onChangeParent: func,
  changeStep: func,
};

Intro.propTypes = {
  onCancelRehab: func,
};

export default Intro;
